import React, { useCallback } from "react";
import "./DeleteProdSpecModal.css";

const DeleteProdSpecModal = ({ show, setShow, specID, deleteSpec }) => {
  const focusinput = useCallback((el) => {
    if (el && show) {
      el.focus();
    }
  });
  return (
    <div className={show ? "custommodal" : "custommodal hide"}>
      <div className='dpsmodal-main'>
        <div>
          <h1>Delete Product Spec</h1>
          <p>Click confirm to delete or Cancel to return.</p>
          <form
            className='delspecbuttons'
            onSubmit={(e) => {
              deleteSpec(specID);
              setShow(false);
            }}
          >
            <button
              type='button'
              onClick={(e) => {
                setShow(false);
              }}
            >
              Cancel
            </button>
            <button type='submit' className='mainbutton' ref={focusinput}>
              Delete
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DeleteProdSpecModal;
